import React from "react";

import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorMode,
} from "@chakra-ui/react";

const getDateFromValue = (value) => {
  const splitDate = value.split('-');
  const formattedDate = `${splitDate[2].substring(0, 2)}/${splitDate[1]}/${splitDate[0]}`;
  const hour = splitDate[2].substring(3, 8);
  
  return formattedDate + " " + hour;
}

const CustomerAssestment = ({ answers }) => {
  const { colorMode } = useColorMode();

  const textColor = colorMode == "light" ? "black" : "white";
  const bgColor = colorMode == "light" ? "gray.200" : "gray.500";

  return (
    <>
      <Flex w="100%" direction="column" mb="20px">
        <Text color={textColor} fontSize="lg" fontWeight="bold" mb="10px">
          Formulário
        </Text>
        <TableContainer width="100%">
          <Table
            variant="striped"
            size="md"
            minW="100%"
            width="100%"
            overflowX="unset"
          >
            <Thead></Thead>
            <Tbody width="100%">
              {answers.map((answer) => {
                if (answer?.field?.title == "imc") {
                  return (
                    <>
                      <Tr >
                        <Td>Altura</Td>
                      </Tr>
                      <Tr>
                        <Td>{answer.response.heigth}m</Td>
                      </Tr>
                      <Tr >
                        <Td>Peso</Td>
                      </Tr>
                      <Tr>
                        <Td>{answer.response.weigth}kg</Td>
                      </Tr>
                    </>
                  );
                } else if (
                  answer?.field?.title == "Data e hora da coleta de sangue"
                ) {
                  return (
                    <>
                      <Tr  w="100%">
                        <Td>{answer.field.title}</Td>
                      </Tr>
                      <Tr>
                        <Td>
                          {answer.response.date} {answer.response.time}
                        </Td>
                      </Tr>
                    </>
                  );
                } else if (
                  answer?.key == "Horário da última dose antes da coleta:"
                ) {
                  return (
                    <>
                      <Tr  w="100%">
                        <Td>{answer.key}</Td>
                      </Tr>
                      <Tr>
                        <Td>
                        {getDateFromValue(answer.value)}
                        </Td>
                      </Tr>
                    </>
                  );
                } else if (
                  answer?.tag == "data_e_hora_da_coleta"
                ) {
                  return (
                    <>
                      <Tr  w="100%">
                        <Td>{answer.key}</Td>
                      </Tr>
                      <Tr>
                        <Td>
                        {getDateFromValue(answer.value)}
                        </Td>
                      </Tr>
                    </>
                  );
                } else {
                  return (
                    <>
                      <Tr >
                        <Td>{answer?.field?.title || answer?.key}</Td>
                      </Tr>
                      <Tr>
                        <Td>
                          {answer?.option?.label
                            ? answer.option.label
                            : answer.value}
                        </Td>
                      </Tr>
                    </>
                  );
                }
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </Flex>
    </>
  );
};

export default CustomerAssestment;
